import { Text } from "@chakra-ui/react";
import { ConfirmDestructiveActionDialog } from "./ConfirmDestructiveActionDialog";
import { WarningTwoIcon } from "@chakra-ui/icons";

interface Props {
  isOpen: boolean;
  onConfirm: (confirmed: boolean) => void;
}

export function ConfirmDirtyNavigationDialog({ isOpen, onConfirm }: Props) {
  return (
    <ConfirmDestructiveActionDialog
      icon={<WarningTwoIcon color="yellow.500" mr={2} />}
      isOpen={isOpen}
      onConfirm={onConfirm}
      title="Er zijn onopgeslagen wijzigingen."
    >
      <Text>Weet je zeker dat je de pagina wilt verlaten?</Text>
      <Text>Je wijzigingen zullen verloren gaan.</Text>
    </ConfirmDestructiveActionDialog>
  );
}
